import React, { useState, useEffect } from 'react'
import { Row, Input } from 'reactstrap'
import { isEmpty, map, uniqBy, head, sortBy } from 'lodash'

const ProductCardOptions = ({
    disabled,
    variants,
    firstVariantValue,
    secondVariantValue,
    thirdVariantValue,
    onChangeFirstVariant,
    onChangeSecondVariant,
    onChangeThirdVariant,
    quantity,
    onChangeQuantity,
    stock,
}) => {
    const [firstVariantLabel, setFirstVariantLabel] = useState('')
    const [firstVariants, setFirstVariants] = useState([])

    const [secondVariantLabel, setSecondVariantLabel] = useState('')
    const [secondVariants, setSecondVariants] = useState([])

    const [thirdVariantLabel, setThirdVariantLabel] = useState('')
    const [thirdVariants, setThirdVariants] = useState([])

    const [thisQuantity, setThisQuantity] = useState(1)

    useEffect(() => {
        if (!isEmpty(variants)) {
            const firstOption = []
            const secondOption = []
            const thirdOption = []

            map(variants, (i) => {
                if (!isEmpty(i.firstOption.value)) {
                    firstOption.push({
                        label: i.firstOption.value,
                        value: i.firstOption.value,
                        stock: i.stock.currentStock
                    })
                }

                if (!isEmpty(i.secondOption.value)) {
                    secondOption.push({
                        label: i.secondOption.value,
                        value: isNaN(Number(i.secondOption.value)) ? i.secondOption.value : Number(i.secondOption.value),
                        stock: i.stock.currentStock
                    })
                }

                if (!isEmpty(i.thirdOption.value)) {
                    thirdOption.push({
                        label: i.thirdOption.value,
                        value: i.thirdOption.value,
                        stock: i.stock.currentStock
                    })
                }
            })

            // Eliminar variantes repetidas
            const uniqFirstOption = uniqBy(firstOption, 'value')
            const uniqSecondOption = uniqBy(secondOption, 'value')
            const uniqThirdOption = uniqBy(thirdOption, 'value')

            // Ordenar variantes de menor a mayor ó alfabetico
            const firstOptionSorted = sortBy(uniqFirstOption, ['value'])
            const secondOptionSorted = sortBy(uniqSecondOption, ['value'])
            const thirdOptionSorted = sortBy(uniqThirdOption, ['value'])
            // Asignar
            setFirstVariants(firstOptionSorted)
            setSecondVariants(secondOptionSorted)
            setThirdVariants(thirdOptionSorted)

            setFirstVariantLabel(head(variants).firstOption.label)
            setSecondVariantLabel(head(variants).secondOption.label)
            setThirdVariantLabel(head(variants).thirdOption.label)
        }
    }, [variants]) // eslint-disable-line

    useEffect(() => {
        if (firstVariants.length === 1) {
            onChangeFirstVariant(head(firstVariants).value)
        }
    }, [firstVariants]) // eslint-disable-line

    useEffect(() => {
        if (secondVariants.length === 1) {
            onChangeSecondVariant(head(secondVariants).value)
        }
    }, [secondVariants]) // eslint-disable-line

    useEffect(() => {
        if (thirdVariants.length === 1) {
            onChangeThirdVariant(head(thirdVariants).value)
        }
    }, [thirdVariants]) // eslint-disable-line

    const renderStock = () => {
        let render = false
        if (!isEmpty(firstVariants) && !isEmpty(firstVariantValue.toString())) {
            render = true
        } else if (!isEmpty(firstVariants) && isEmpty(firstVariantValue.toString())) {
            render = false
        }

        if (!isEmpty(secondVariants) && !isEmpty(secondVariantValue.toString())) {
            render = true
        } else if (!isEmpty(secondVariants) && isEmpty(secondVariantValue.toString())) {
            render = false
        }

        if (!isEmpty(thirdVariants) && !isEmpty(thirdVariantValue.toString())) {
            render = true
        } else if (!isEmpty(thirdVariants) && isEmpty(thirdVariantValue.toString())) {
            render = false
        }

        if (isEmpty(firstVariants) && isEmpty(secondVariants) && isEmpty(thirdVariants)) {
            render = true
        }

        return render ? (
            <Row>
                <div style={{ marginBottom: '10px' }}>{stock} {stock === 1 ? 'unidad disponible' : 'unidades disponibles'}</div>
            </Row>
        ) : null
    }

    return (
        <React.Fragment>
            <Row>
                <div style={{ justifyContent: 'center' }}>
                    {
                        !isEmpty(firstVariants) && (
                            <Row style={{ marginBottom: '10px' }}>
                                <div>
                                    <div>
                                        <label>Seleccione {firstVariantLabel}</label>
                                    </div>
                                    <div style={{ display: 'block' }}>
                                        {firstVariants.map((item, i) => {
                                            return (
                                                <button
                                                    className="product-option-item-circle rounded"
                                                    key={i}
                                                    onClick={() => onChangeFirstVariant(item.value)}
                                                    disabled={item.stock === 0}
                                                    style={{
                                                        backgroundColor: firstVariantValue === item.value ? '#ec595f' : 'white',
                                                        color: item.stock === 0 ? '#cccccc' : firstVariantValue === item.value ? 'white' : 'black',
                                                        marginBottom: '10px',
                                                    }}
                                                >
                                                    {item.label}
                                                </button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </Row>
                        )
                    }
                    {
                        !isEmpty(secondVariants) && (
                            <Row style={{ marginBottom: '10px' }}>
                                <div>
                                    <div>
                                        <label>Seleccione {secondVariantLabel}</label>
                                    </div>
                                    <div style={{ display: 'block' }}>
                                        {secondVariants.map((item, i) => {
                                            return (
                                                <button
                                                    className="product-option-item-circle rounded"
                                                    key={i}
                                                    onClick={() => onChangeSecondVariant(item.value)}
                                                    disabled={item.stock === 0}
                                                    style={{
                                                        backgroundColor: secondVariantValue === item.value ? '#ec595f' : 'white',
                                                        color: item.stock === 0 ? '#cccccc' : secondVariantValue === item.value ? 'white' : 'black',
                                                        marginBottom: '10px',
                                                    }}
                                                >
                                                    {item.label}
                                                </button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </Row>
                        )
                    }
                    {
                        !isEmpty(thirdVariants) && (
                            <Row style={{ marginBottom: '10px' }}>
                                <div sm="12">
                                    <div>
                                        <label>Seleccione {thirdVariantLabel}</label>
                                    </div>
                                    <div style={{ display: 'block' }}>
                                        {thirdVariants.map((item, i) => {
                                            return (
                                                <button
                                                    className="product-option-item-circle rounded"
                                                    key={i}
                                                    onClick={() => onChangeThirdVariant(item.value)}
                                                    disabled={item.stock === 0}
                                                    style={{
                                                        backgroundColor: thirdVariantValue === item.value ? '#ec595f' : 'white',
                                                        color: item.stock === 0 ? '#cccccc' : thirdVariantValue === item.value ? 'white' : 'black',
                                                        marginBottom: '10px',
                                                    }}
                                                >
                                                    {item.label}
                                                </button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </Row>
                        )
                    }
                    {renderStock()}
                    <Row>
                        <div>
                            {
                                parseInt(quantity) < 10 && (
                                    <React.Fragment>
                                        <div>
                                            <label>Cantidad</label>
                                        </div>
                                        <Input
                                            type="select"
                                            className="custom-select"
                                            value={quantity}
                                            id="quantity"
                                            name="quantity"
                                            disabled={disabled}
                                            onChange={(event) => {
                                                setThisQuantity(event.target.value)
                                                onChangeQuantity(event.target.value)
                                            }}>
                                            <option key="0" value="0">Cantidad</option>
                                            <option key={1} value="1">1</option>
                                            <option key={2} value="2">2</option>
                                            <option key={3} value="3">3</option>
                                            <option key={4} value="4">4</option>
                                            <option key={5} value="5">5</option>
                                            <option key={6} value="6">6</option>
                                            <option key={7} value="7">7</option>
                                            <option key={8} value="8">8</option>
                                            <option key={9} value="9">9</option>
                                            <option key={10} value="10">10+</option>
                                        </Input>
                                    </React.Fragment>
                                )
                            }
                            {
                                parseInt(quantity) >= 10 && (
                                    <Input
                                        type="number"
                                        id="quantity"
                                        name="quantity"
                                        autoFocus
                                        disabled={disabled}
                                        onFocus={(event) => {
                                            event.target.select()
                                        }}
                                        value={thisQuantity}
                                        placeholder="Cantidad..."
                                        onChange={(event) => {
                                            setThisQuantity(event.target.value)
                                        }}
                                        onBlur={(event) => {
                                            onChangeQuantity(event.target.value)
                                        }}
                                    />
                                )
                            }
                        </div>
                    </Row>
                </div>
            </Row>
        </React.Fragment>
    )
}

export default ProductCardOptions
